const jp = {
    menu_home: "トップページ",
    menu_SpeRetrieve: "特色クエリー",
    menu_CLCRetrieve: "中図分類法クエリー",
    menu_AdvanceRetrieve: "高度な検索",
    menu_BookMarkRetrieve: "ブックマーク検索",
    menu_Notes: "情報公告",
    menu_Mylibray: "私の図書館",

    field_hit: '命中数',
    field_author: '責任者',
    field_pubdate: '出版時間',
    field_content: '叢書名',
    field_pages: 'ページ数',
    field_publisher: '出版社',
    field_clcno: '分類番号',
    field_price: '価格',

    field_title: '題名',
    field_callno: '索書号',
    field_subject: '主題語',
    field_pubyear: '出版年',
    field_anyword: "任意の言葉",

    field_frontMatch: "前方一致",
    field_exactMatch: "エクシブマッチ",
    field_fuzzyRetrieve: "ファジイ検索",

    field_labelOrder: "ソート順",
    field_orderAsc: "昇順",
    field_orderDesc: "降順",

    field_tipInputKeyword: "検索するキーワードを入力してください",
    field_retrieve: "検索",
    field_retrieveInReult: "結果の検索",

    field_recordsPerPage: "各ページに表示"
};

export default jp;